import { hudlTheme } from '@statsbomb/kitbag-themes';

export function getAppTheme(isDark) {
  return isDark ? hudlTheme.dark : hudlTheme.light;
}
